import { string, func, bool } from 'prop-types';
import themeColors from 'styles/themes/colors';

const ArtworkImage = ({
  src,
  maskId,
  onError,
  entityType,
  isVersion,
  forBreadcrumb,
}) => {
  if (isVersion) {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <>
            <rect
              fillOpacity="0.15"
              fillRule="evenodd"
              fill={themeColors.NightBlue}
              x="5"
              y="5"
              width="90"
              height="90"
              rx="3"
            />
            <image
              xlinkHref={src}
              x="20"
              y="20"
              width="60"
              height="60"
              clipPath={`url(#${maskId})`}
              onError={onError}
            />
          </>
        );
      default:
        return null;
    }
  }

  if (forBreadcrumb) {
    return (
      <image
        xlinkHref={src}
        x="0"
        y="0"
        width="30"
        height="30"
        clipPath={`url(#${maskId})`}
        onError={onError}
      />
    );
  } else {
    switch (entityType) {
      case 'release':
      case 'list':
      case 'track':
        return (
          <image
            xlinkHref={src}
            x="5"
            y="5"
            width="90"
            height="90"
            clipPath={`url(#${maskId})`}
            onError={onError}
          />
        );
      case 'artist':
      case 'label':
        return (
          <image
            xlinkHref={src}
            x="0"
            y="0"
            width="100"
            height="100"
            clipPath={`url(#${maskId})`}
            onError={onError}
          />
        );
      case 'project':
        return (
          <>
            <image
              xlinkHref={src}
              x="5"
              y="5"
              width="90"
              height="90"
              clipPath={`url(#${maskId})`}
              onError={onError}
            />
            <image
              xlinkHref={src}
              x="53"
              y="5"
              width="42"
              height="42"
              clipPath={`url(#${maskId})`}
              onError={onError}
            />
            <image
              xlinkHref={src}
              x="53"
              y="53"
              width="42"
              height="42"
              clipPath={`url(#${maskId})`}
              onError={onError}
            />
          </>
        );
      default:
        return null;
    }
  }
};

ArtworkImage.propTypes = {
  src: string.isRequired,
  maskId: string.isRequired,
  onError: func.isRequired,
  entityType: string.isRequired,
  isVersion: bool,
  forBreadcrumb: bool,
};

export default ArtworkImage;
